import * as api from "../api";

import { FETCH_ALL, DELETE, UPDATE, CREATE } from "../constants/actionTypes";

export const getPosts = () => async (dispatch) => {
    try {
        const { data } = await api.fetchPosts();
        dispatch({ type: FETCH_ALL, payload: data })
        console.log("FETCH ALL POSTS", data)
    } catch (error) {
        console.log(error.message)
    }
}

export const createPost = (values, setLoading, clear, toast) => async (dispatch) => {
    try {
        setLoading(true)
        const { data } = await api.createPost(values);
        dispatch({ type: CREATE, payload: data });

        dispatch(getPosts())
        setLoading(false)
        toast.success('Post created successfully')
        clear()

    } catch (error) {
        setLoading(true)
        toast.error(error.response.data || 'ERR_CONNECTION_REFUSED');
        console.log(error)
    }
}

export const updatePost = (id, post, setLoading, navigate, clear, toast) => async (dispatch) => {
    try {
        setLoading(true)
        const { data } = await api.updatePost(id, post);
        dispatch({ type: UPDATE, payload: data });

        dispatch(getPosts())
        setLoading(false)
        toast.success("Post edited Successfully");

        setTimeout(() => {
            navigate('/posts');
        }, 2000);

    } catch (error) {
        setLoading(false)
        console.log(error);
        toast.error(error.response.data || 'ERR_CONNECTION_REFUSED');
    }
}

export const deletePost = (id, setLoading, setShowAlert, toast) => async (dispatch) => {
    setLoading(true)
    try {
        await api.deletePost(id);
        dispatch({ type: DELETE, payload: id });
        dispatch(getPosts())
        setLoading(false)
        setShowAlert(false)
        toast.success("Post deleted Successfully");
    } catch (error) {
        setLoading(false)
        toast.error(error.response.data || 'ERR_CONNECTION_REFUSED');
        console.log(error)
    }
}